/**
 * Known Helo hard coded roles.
 *
 * Do no include customer roles to prevent leaking customer names.
 */
export const roles = {
  /** Helo internal team users? */
  heloInternal: 'Helo-Internal',
  /** Beta feature access */
  betaUser: 'Beta-User',
  /** Helo customers */
  heloCustomerPrefix: `Helo-Customer-`,
} as const

/** Internal Helo Roles OR the customer role pattern of
 * `Helo-Customer-CustomerName`
 */
export type Role =
  | (typeof roles)[keyof typeof roles]
  | `Helo-Customer-${string}`
  | ({} & string)
